import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { v4 as uuidv4 } from 'uuid';

import schedulingApis from '../../../api/services/scheduling.service';
import templateAPIs from '../../../api/services/template.service';

const initialState = {
  value: [],
  loading: false,
  error: false,
  isEditing: false,
  templateId: '',
  fullData: [],
  authorizationCode: [],
  newNote: [],
  savingNote: '',
  clientProviderDetails: [],
  copiedData: [],
  name: [],
  saveNoteByCodeData: false,
  listOfSessionNote: '',
  selectSummaryTargetData: [],
  showSelected: {},
  isGridEdit: false,
  checkStatus: '',
  pullSessionNotefullData: '',
  billingRecord: '',
  autoFillSummary: false,
  isSessionSummaryComponent: false,
};
interface Data {
  templateId: any;
  organizationId: string;
  type: string;
}
interface authoCode {
  codeType: string;
}
interface code {
  authorizationCode: any;
  appointmentId: string;
  sessionNotesDataId: string;
  appointmentRecurrenceId: any;
}
interface GetNewNoteData {
  sessionNoteTemplateId: any;
  childPayerId: any;
  appointmentId: any;
  appointmentRecurrenceId: any;
}
interface GetMultipleNoteByCode {
  authorizationCode: any;
}
interface CheckSessionNoteExists {
  appointmentId: any;
  sessionNoteDataId: string;
  billingCode: string;
}
interface saveNewNoteData {
  appointmentId: any;
  authorizationCode: any;
  sessionTemplateId: any;
  sessionNoteData: any;
  createdBy: any;
  modifiedBy: any;
  sessionNotesDataId: any;
  appointmentWith: any;
  organizationLogo: string;
  authorizationCodes: any;
  unitOfService: any;
  additionalParticipants: any;
  childPayerId: any;
  isExistingSessionNoteSelected?: any;
  name: any;
  cosignedBy: any;
  coSignatureData: any;
  logoConfig: any;
  isSessionNoteDataEdited: any;
}
interface GetClientProvider {
  providerId: any;
  clientId: any;
  appointmentId: any;
  appointmentRecurrenceId: any;
}
interface GetCInterventionClientProvider {
  providerId: any;
  clientId: any;
  organizationServiceId: any;
}
interface GetProgramBookClientProvider {
  providerId: any;
  clientId: any;
  authorizationCodeId: any;
}
interface copySessionNote {
  sessionNoteDataId: any;
  appointmentWith: any;
  currentDateAndTime: any;
}
interface getNoteData {
  sessionNoteDataId: any;
  appointmentId: any;
  isExistingNote: any;
  appointmentDate: any;
  appointmentRecurrenceId: any;
}
export const getById = createAsyncThunk('getById', async (payload: Data, { rejectWithValue }) => {
  try {
    const res = await templateAPIs.findById(payload);
    const datReturn = res.data.data?.instructionTemplate?.data
      ? JSON.parse(res.data.data.instructionTemplate.data).template
      : {};
    const fullData = res.data.data;
    if (Object.keys(datReturn).length) {
      return {
        datReturn,
        otherData: res.data.data.template,
        fullData,
      };
    } else {
      return {
        fullData,
      };
    }
  } catch (err) {
    rejectWithValue('Error in Response');
  }
});
export const getNewNoteCode = createAsyncThunk(
  'getNewNoteCode',
  async (payload: GetNewNoteData, { rejectWithValue }) => {
    try {
      const res = await schedulingApis.getNewNoteByCode(payload);
      const datReturn = JSON.parse(res.data.data.data).template;
      return {
        datReturn,
        otherData: res.data.data.data,
        fullData: res.data.data,
      };
    } catch (err) {
      rejectWithValue('Error in Response');
    }
  }
);
export const getMultipleNoteByCode = createAsyncThunk(
  'getMultipleNoteByCode',
  async (payload: GetMultipleNoteByCode, { rejectWithValue }) => {
    try {
      const res = await schedulingApis.getMultipleNoteByCode(payload);
      return res.data;
    } catch (err) {
      rejectWithValue('Error in Response');
    }
  }
);
export const checkSessionNoteExists = createAsyncThunk(
  'checkSessionNoteExists',
  async (payload: CheckSessionNoteExists, { rejectWithValue }) => {
    try {
      const res = await schedulingApis.checkSessionNoteExists(payload);
      return res.data;
    } catch (err) {
      rejectWithValue('Error in Response');
    }
  }
);
export const getNoteById = createAsyncThunk(
  'getNoteById',
  async (payload: getNoteData, { rejectWithValue }) => {
    try {
      const res = await schedulingApis.getNoteById(payload);
      const datReturn = JSON.parse(res.data.data.sessionNoteData);
      return {
        datReturn,
        otherData: res.data.data.data,
        fullData: res.data.data,
      };
    } catch (err) {
      rejectWithValue('Error in Response');
    }
  }
);
export const getClientProviderDetails = createAsyncThunk(
  'getClientProviderDetails',
  async (payload: GetClientProvider, { rejectWithValue }) => {
    try {
      const res = await schedulingApis.getClientProviderDetails(payload);
      return res.data;
    } catch (err) {
      rejectWithValue('Error in Response');
    }
  }
);

export const getiInterventionClientProviderDetails = createAsyncThunk(
  'getiInterventionClientProviderDetails',
  async (payload: GetCInterventionClientProvider, { rejectWithValue }) => {
    try {
      const res = await schedulingApis.getInterventionClientProviderDetails(payload);
      return res.data;
    } catch (err) {
      rejectWithValue('Error in Response');
    }
  }
);
export const getProgramClientProviderDetails = createAsyncThunk(
  'getProgramClientProviderDetails',
  async (payload: GetProgramBookClientProvider, { rejectWithValue }) => {
    try {
      const res = await schedulingApis.getProgramClientProviderDetails(payload);
      return res.data;
    } catch (err) {
      rejectWithValue('Error in Response');
    }
  }
);
export const copySessionNoteById = createAsyncThunk(
  'copySessionNoteById',
  async (payload: copySessionNote, { rejectWithValue }) => {
    try {
      const res = await schedulingApis.copySessionNoteById(payload);
      return res.data;
    } catch (err) {
      rejectWithValue('Error in Response');
    }
  }
);
export const saveNoteByCode = createAsyncThunk(
  'saveNoteByCode',
  async (payload: saveNewNoteData, { rejectWithValue }) => {
    try {
      const res = await schedulingApis.saveNoteByCode(payload);
      return res.data;
    } catch (err) {
      rejectWithValue('Error in Response');
    }
  }
);
export const getAuthorizationCode = createAsyncThunk(
  'getAuthorizationCode',
  async (payload: authoCode, { rejectWithValue }) => {
    try {
      const res = await templateAPIs.getAuthorizationCode(payload);
      return res.data;
    } catch (err) {
      rejectWithValue('Error in Response');
    }
  }
);
export const getNameOfNote = createAsyncThunk(
  'getNameOfNote',
  async (payload: code, { rejectWithValue }) => {
    try {
      const res = await templateAPIs.getNameOfNote(payload);
      return res.data;
    } catch (err) {
      rejectWithValue('Error in Response');
    }
  }
);
const templateSlice = createSlice({
  name: 'template',
  initialState,
  reducers: {
    setElements: (state: any, action: any) => {
      state.value = [...action.payload];
    },
    deleteElement: (state: any, action: { payload: any }) => {
      // Filter the array to remove the item with the given id
      state.value = state.value.filter((item: any) => item.id !== action.payload);

      // Optionally, reindex the array by setting the id based on the current index
      state.value = state.value.map((item: any, index: number) => {
        item.index = index; // Assuming you're tracking index in the item object
        return item;
      });
    },

    addElement: (state: any, action: any) => {
      // Ensure state.value is initialized as an array
      if (!Array.isArray(state.value)) {
        state.value = [];
      }
      // Generate a new ID and add the new element with the provided payload
      const id = uuidv4();
      state.value = [...state.value, { ...action.payload, id, index: state.value.length }];
    },
    addElementAtIndex: (state: any, action: any) => {
      if (!Array.isArray(state.value)) {
        state.value = [];
      }
      const { element, index } = action.payload;
      const id = uuidv4();
      const newElement = { ...element, id, index };
      const newValue = [...state.value];
      newValue.splice(index, 0, newElement);
      // Reindex the array
      state.value = newValue.map((item, idx) => ({
        ...item,
        index: idx,
      }));
    },
    updateElement: (state: any, action: { payload: any }) => {
      const { id, data } = action.payload;
      state.value = state.value.map((item: any) => {
        if (item.id === id) {
          return {
            ...item,
            ...data,
          };
        } else return item;
      });
    },
    updateOption: (state: any, action: { payload: any }) => {
      const { id } = action.payload;
      state.value = state.value.map((item: any) => {
        if (item.id === id) {
          return {
            ...item,
            options: [...action.payload.optionData],
          };
        } else return item;
      });
    },
    deleteOption: (state: any, action: { payload: any }) => {
      const stateData = state.value.map((data: any) => {
        if (data.id === action.payload.activeEl) {
          return {
            ...data,
            options: action.payload.updatedOptionsValue,
          };
        }
        return data;
      });
      state.value = stateData;
    },
    moveElements: (state: any, action: { payload: any }) => {
      const { dragIndex, hoverIndex } = action.payload;
      // console.log(`Moving item from ${dragIndex} to ${hoverIndex}`);
      const elements = [...state.value];
      const [dragItem] = elements.splice(dragIndex, 1); // Remove once

      elements.splice(hoverIndex, 0, dragItem); // Insert at correct position

      const resultArr = elements.map((item, index) => ({
        ...item,
        index,
      }));

      state.value = resultArr;
    },
    setAutoFillSummary: (state: any, action) => {
      const { id, enabled } = action.payload;

      state.value = state.value.map((item: any) => ({
        ...item,
        autoFillSummary: item.id === id ? enabled : false,
      }));
    },
    setIsSessionSummaryComponent: (state: any, action) => {
      const { id, isSessionSummaryComponent } = action.payload;

      state.value = state.value.map((item: any) => ({
        ...item,
        isSessionSummaryComponent: item.id === id ? isSessionSummaryComponent : false,
      }));
    },

    clearingData: (state: any) => {
      state.value = [];
      state.name = '';
      state.description = '';
      state.fullData = [];
      state.savingNote = '';
    },
    clearNote: (state: any) => {
      state.newNote = [];
      state.saveNoteByCodeData = false;
    },
    updateNote: (state: any, action: { payload: any }) => {
      const { id, data } = action.payload;
      state.newNote = state.newNote.map((item: any) => {
        if (item.id === id) {
          return {
            ...item,
            ...data,
          };
        } else return item;
      });
    },
    savingOnEdit: (state, action) => {
      state.isEditing = action.payload;
    },
    savingTemplateId: (state, action) => {
      state.templateId = action.payload;
    },
    savingNote: (state, action) => {
      state.savingNote = action.payload;
    },
    setSaveNoteByCodeData: (state, action) => {
      state.saveNoteByCodeData = action.payload;
    },
    setMultipleCodes: (state: any, action: any) => {
      state.listOfSessionNote = action.payload;
    },
    setSummaryData: (state: any, action: any) => {
      state.selectSummaryTargetData = action.payload;
    },
    showSelectedData: (state, action) => {
      state.showSelected = action.payload;
    },
    clearSummary: state => {
      state.selectSummaryTargetData = [];
      state.showSelected = {};
    },
    setIsEditingGrid: (state, action) => {
      state.isGridEdit = action.payload;
    },
    setFullData: (state, action) => {
      state.pullSessionNotefullData = action.payload;
    },
    setParticularRecord: (state, action) => {
      state.billingRecord = action.payload;
    },
    clearBillingRecord: state => {
      state.billingRecord = '';
    },
    setEditableData: (state, action) => {
      state.value = action.payload?.datReturn || [];
      state.fullData = action.payload?.fullData;
      state.isEditing = true;
      state.loading = false;
    },
    clearClientProviderDetails: state => {
      state.clientProviderDetails = [];
    },
  },
  extraReducers: builder => {
    builder
      .addCase(getById.pending, (state: any) => {
        state.loading = true;
      })
      .addCase(getById.fulfilled, (state: any, action) => {
        state.value = action.payload?.datReturn || [];
        state.name = action.payload?.otherData?.name;
        state.fullData = action.payload?.fullData;
        state.description = action.payload?.otherData?.description;
        state.isEditing = true;
        state.loading = false;
      })
      .addCase(getById.rejected, (state: any) => {
        state.loading = false;
      })
      .addCase(getAuthorizationCode.pending, (state: any) => {
        state.loading = true;
      })
      .addCase(getAuthorizationCode.fulfilled, (state: any, action) => {
        state.authorizationCode = action.payload;
      })
      .addCase(getAuthorizationCode.rejected, (state: any) => {
        state.loading = true;
      })
      .addCase(getNewNoteCode.pending, (state: any) => {
        state.loading = true;
      })
      .addCase(getNewNoteCode.fulfilled, (state: any, action) => {
        state.newNote = action.payload?.datReturn;
        state.fullData = action.payload?.fullData;
      })
      .addCase(getNewNoteCode.rejected, (state: any) => {
        state.loading = true;
      })
      .addCase(getMultipleNoteByCode.pending, (state: any) => {
        state.loading = true;
      })
      .addCase(getMultipleNoteByCode.fulfilled, (state: any, action) => {
        state.listOfSessionNote = action.payload;
      })
      .addCase(checkSessionNoteExists.fulfilled, (state: any, action) => {
        state.checkStatus = action.payload;
      })
      .addCase(getMultipleNoteByCode.rejected, (state: any) => {
        state.loading = true;
      })
      .addCase(getClientProviderDetails.pending, (state: any) => {
        state.loading = true;
      })
      .addCase(saveNoteByCode.fulfilled, (state: any, action) => {
        state.saveNoteByCodeData = action.payload;
      })
      .addCase(getClientProviderDetails.fulfilled, (state: any, action) => {
        state.clientProviderDetails = action.payload;
      })
      .addCase(getiInterventionClientProviderDetails.pending, (state: any) => {
        state.loading = true;
      })
      .addCase(getiInterventionClientProviderDetails.fulfilled, (state: any, action) => {
        state.clientProviderDetails = action.payload;
      })
      .addCase(getiInterventionClientProviderDetails.rejected, (state: any) => {
        state.loading = true;
      })
      .addCase(getProgramClientProviderDetails.pending, (state: any) => {
        state.loading = true;
      })
      .addCase(getProgramClientProviderDetails.fulfilled, (state: any, action) => {
        state.clientProviderDetails = action.payload;
        state.loading = false;
      })
      .addCase(getProgramClientProviderDetails.rejected, (state: any) => {
        state.loading = true;
      })
      .addCase(copySessionNoteById.pending, (state: any) => {
        state.loading = true;
      })
      .addCase(copySessionNoteById.fulfilled, (state: any, action) => {
        state.copiedData = action.payload;
      })
      .addCase(copySessionNoteById.rejected, (state: any) => {
        state.loading = true;
      })
      .addCase(getNoteById.pending, (state: any) => {
        state.loading = true;
      })
      .addCase(getNoteById.fulfilled, (state: any, action) => {
        state.newNote = action.payload?.datReturn;
        state.fullData = action.payload?.fullData;
      })
      .addCase(getNoteById.rejected, (state: any) => {
        state.loading = true;
      })
      .addCase(getNameOfNote.pending, (state: any) => {
        state.loading = true;
      })
      .addCase(getNameOfNote.fulfilled, (state: any, action) => {
        state.name = action.payload;
      })
      .addCase(getNameOfNote.rejected, (state: any) => {
        state.loading = true;
      });
  },
});
export const {
  setElements,
  addElement,
  addElementAtIndex,
  moveElements,
  deleteElement,
  updateElement,
  updateOption,
  clearingData,
  deleteOption,
  savingOnEdit,
  savingTemplateId,
  savingNote,
  clearNote,
  setSaveNoteByCodeData,
  setMultipleCodes,
  setSummaryData,
  showSelectedData,
  clearSummary,
  setIsEditingGrid,
  setFullData,
  setParticularRecord,
  clearBillingRecord,
  updateNote,
  setEditableData,
  setAutoFillSummary,
  setIsSessionSummaryComponent,
  clearClientProviderDetails,
} = templateSlice.actions;
export default templateSlice.reducer;
